import React from "react";
import { File, FileCode2, Folder, Search } from "lucide-react";
import { formatBytes } from "../lib/utils";
import { CopyButton, SectionHeader } from "./Primitives";
import { useLocale } from "../lib/i18n";

export default function FileView({ sample }) {
  const { t } = useLocale();
  const [selected, setSelected] = React.useState(sample.files.find((file) => file.relative === "task.toml")?.relative || sample.files[0]?.relative || "");
  const [query, setQuery] = React.useState("");
  React.useEffect(() => {
    setSelected(sample.files.find((file) => file.relative === "task.toml")?.relative || sample.files[0]?.relative || "");
  }, [sample.id]);
  const file = sample.byRelative.get(selected);
  const files = sample.files.filter((entry) => entry.relative.toLowerCase().includes(query.toLowerCase()));
  return (
    <div className="file-layout panel">
      <aside className="file-tree">
        <div className="file-tree-head"><Folder size={15} /><strong>{sample.id}</strong></div>
        <div className="search-box"><Search size={13} /><input value={query} onChange={(event) => setQuery(event.target.value)} placeholder={t("file.filter")} /></div>
        <div className="file-list">
          {files.map((entry) => (
            <button className={selected === entry.relative ? "active" : ""} key={entry.relative} onClick={() => setSelected(entry.relative)}>
              {entry.kind === "text" ? <FileCode2 size={13} /> : <File size={13} />}
              <span>{entry.relative}</span>
              <small>{formatBytes(entry.size)}</small>
            </button>
          ))}
        </div>
      </aside>
      <section className="file-content">
        <SectionHeader
          eyebrow={t("file.local")}
          title={selected || t("file.select")}
          aside={file?.kind === "text" ? <CopyButton value={file.text} label={t("file.copy")} /> : null}
        />
        {file?.kind === "text" ? <pre className="source-code">{file.text}</pre> : <div className="missing-panel">{t("file.binary", { size: formatBytes(file?.size || 0) })}</div>}
      </section>
    </div>
  );
}
